import React from 'react'
import TagManager from 'react-gtm-module'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import * as History from 'history'
import 'styles/base.module.scss'
import 'styles/myCustomWysiwyg.css'
import App from 'App'
import createStore from 'reducks/reduxStore/store'
import reportWebVitals from './reportWebVitals'
import { VersionChecker } from 'components/Utility'

// Fire GTM tag only if the env is Production
if (process.env.REACT_APP_PROJECT_ID === 'sacri-6bae3') {
  const tagManagerArgs = { gtmId: 'GTM-TF4BJFP' }
  TagManager.initialize(tagManagerArgs)
}

// connected-react-router - action経由でルーティングが可能、push,replace..
// historyを強化
const history = History.createBrowserHistory()
export const store = createStore(history)
export type State = ReturnType<typeof store.getState>

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <VersionChecker>
        <App />
      </VersionChecker>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)

reportWebVitals(console.log)
